module.exports = __webpack_public_path__ + "img/alarm.a723080f.svg";